import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Divider, Grid, Typography } from '@material-ui/core';
import TooltipButton from '../shared/TooltipButton';
import PatientIdIcon from '../../assets/image/patient/patient_id.svg';
import PatientNameIcon from '../../assets/image/patient/patient_name.svg';
import { AppContext } from '../App';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Tr from '../shared/tr';

interface ImageInfoDlgProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: '640px',
    },
    grid: {
      marginTop: '32px',
      marginLeft: '10px',
    },
    btn: {
      margin: 'auto',
      marginBottom: 20,
      textTransform: 'none',
      background: '#E2F8FC',
      color: '#000000',
      '&:hover': {
        background: '#36B0C9',
        color: '#ffffff',
      },
      minWidth: 80,
      minHeight: 32,
    },
  })
);

function ImageInfoDlg(props: ImageInfoDlgProps) {
  const classes = useStyles();
  const { patient, acqInfo } = useContext(AppContext);
  console.log('origin patient id: ', patient.id);
  const tr = new Tr();
  const gridRow = (key: string, value: string) => {
    return (
      <>
        <Grid item xs={4}>
          <Typography gutterBottom variant="body2">
            {key}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography gutterBottom variant="subtitle2">
            {value}
          </Typography>
        </Grid>
      </>
    );
  };
  return (
    <Dialog open={props.open} maxWidth={'md'}>
      <DialogTitle>{tr.titlebarImageInfo()}</DialogTitle>
      <div className={classes.root}>
        <DialogContent>
          <Grid container spacing={2} alignItems="center" justify="center">
            <Grid item container xs={12} className={classes.grid}>
              <Grid item xs={1}>
                <TooltipButton title={tr.imageInfoPatientName()} imgSrc={PatientNameIcon}></TooltipButton>
              </Grid>
              <Grid item xs={4}>
                <Typography gutterBottom variant="body2">
                {tr.imageInfoPatientName()}:
                </Typography>
                <Typography noWrap gutterBottom variant="subtitle2">
                  {patient.firstName} {patient.lastName}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <TooltipButton title={tr.imageInfoPatientID()} imgSrc={PatientIdIcon}></TooltipButton>
              </Grid>
              <Grid item xs={6}>
                <Typography gutterBottom variant="body2">
                {tr.imageInfoPatientID()}:
                </Typography>
                <Typography noWrap gutterBottom variant="subtitle2">
                  {patient.id?.substring(1, patient.id.length - 1)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Divider variant="middle" />

          <Grid item container xs={12} spacing={2} alignItems="center" className={classes.grid}>
            {gridRow(tr.imageInfoAcquisitionTime(), acqInfo.acquisitionTime)}
            {gridRow(tr.imageInfoModelName(), acqInfo.manufactModeName)}
            {gridRow(tr.imageInfoSerialNumber(), acqInfo.deviceSerialNum)}
            {gridRow(tr.imageInfoAcquisitionType(), acqInfo.acquisitionType)}
            {gridRow(tr.imageInfoSoftwareVersion(), acqInfo.acquisitionSoftwareVersion)}
          </Grid>
        </DialogContent>
      </div>
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose();
          }}
          color="primary"
          className={classes.btn}
          autoFocus
        >
          {tr.generalOK()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ImageInfoDlg;
